import React from 'react';

import SynonymMeaning from '../SynonymMeaning';
import SynonymWord from '../SynonymWord';

export default class SynonymSearch extends React.Component {
  state = {
    selectedMeaning: undefined,
  };

  render() {
    const meanings = this.props.meanings[this.props.word];

    if (!meanings || meanings.length == 0) {
      return (
        <div className="synonym-list">
          <span className="no-meanings-found-text">
            No Meanings found for this word
          </span>
        </div>
      );
    }

    const selectedMeaning = this.state.selectedMeaning || meanings[0];
    return (
      <div className="synonym-list">
        <div className="synonym-list-meanings">
          {meanings.map((meaning, i) => (
            <SynonymMeaning
              onClick={e => this._setSelectedMeaning(meaning)}
              key={i}
              text={meaning.definition}
              selected={meaning.definition == selectedMeaning.definition}
              addMode
              onAdd={e => this._addMeaning(meaning)}
            />
          ))}
        </div>
        <div className="synonym-list-words">
          {selectedMeaning.synonyms.sort().map((synonym, i) => (
            <SynonymWord key={i} text={synonym} addMode />
          ))}
        </div>
      </div>
    );
  }

  _setSelectedMeaning = selectedMeaning => {
    this.setState({ selectedMeaning });
  };

  _addMeaning = meaning => {
    this.props.onAdd(meaning);
  };
}
